<template>
  <Modal v-bind:open="open" @close="close">
    <div>
      <h1 class="text-center font-extrabold text-xl">Résilier le contrat</h1>

      <div v-if="hasBlockers" class="mt-4 space-y-2">
        <Alert v-if="blockers.paymentsNotUpToDate" type="error">
          <strong>Paiements non à jour</strong>
          — la résiliation est bloquée tant que la situation n'est pas régularisée.
        </Alert>
        <Alert v-if="blockers.withinCommitmentPeriod" type="warning">
          <strong>Période d'engagement en cours</strong>
          — le contrat est encore engageant, la résiliation ne prendra effet qu'à la fin de l'engagement.
        </Alert>
        <Alert v-if="blockers.hasApprovedClaim" type="error">
          <strong>Sinistre approuvé sur la période de couverture courante</strong>
          — la résiliation est bloquée avant la fin de l'année en cours.
        </Alert>
      </div>

      <termination-form
        @updateSelectedReason="updateSelectedReason"
        @updateFeedbackMessage="updateFeedbackMessage"
        @updateCancellationDate="updateCancellationDate"
      />

      <div class="mt-4 flex justify-center">
        <GenericButton @click="handlePlanSaleCancel">Résilier</GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, GenericButton, Alert, hasCancellationBlockers } from "@estaly/ui";
import TerminationForm from "@/components/plan_sale/TerminationForm.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Modal,
    GenericButton,
    Alert,
    TerminationForm,
  },

  data() {
    return {
      selectedReason: "",
      feedbackMessage: "",
      cancellationDate: null,
    };
  },

  props: {
    open: { type: Boolean, required: true },
    planSale: { type: Object, required: true },
  },

  computed: {
    blockers() {
      return this.planSale?.cancellationBlockers ?? {};
    },
    hasBlockers() {
      return hasCancellationBlockers(this.blockers);
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),

    handlePlanSaleCancel: function () {
      this.$emit("cancelPlanSale", this.selectedReason, this.feedbackMessage, this.cancellationDate);
    },

    close: function () {
      this.$emit("close");
    },

    updateSelectedReason(value) {
      this.selectedReason = value;
    },

    updateFeedbackMessage(value) {
      this.feedbackMessage = value;
    },

    updateCancellationDate(value) {
      this.cancellationDate = value;
    },
  },
};
</script>
